export default __webpack_public_path__ + "static/media/7.e55794a7.png";